import { Link } from 'react-router-dom';
import { Anchor as MantineAnchor, Box, Sx } from '@mantine/core';

import { DYNAMIC_URLS } from 'consts';
import { OpenIcon } from 'icons';

import { useFormRowContext } from './FormRowContext';

const anchorSx: Sx = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: 600,
  color: 'inherit',
  svg: {
    visibility: 'hidden',
  },
  ':hover': {
    svg: {
      visibility: 'visible',
    },
  },
};

const boxSx: Sx = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

const iconSx: Sx = theme => ({
  flexShrink: 0,
  marginTop: -2,
  marginLeft: theme.other.spacing(0.25),
});

export const AnchorCell = () => {
  const {
    form: { id, name },
  } = useFormRowContext();

  return (
    <td>
      <MantineAnchor
        sx={anchorSx}
        component={Link}
        to={DYNAMIC_URLS.formEdit({ formId: id })}
      >
        <Box sx={boxSx} component="span">
          {name}
        </Box>
        <OpenIcon sx={iconSx} />
      </MantineAnchor>
    </td>
  );
};
